import { makeStyles } from '@mui/styles';
import Skeleton from '@classify/react-core-components/Skeleton';

import styles from './styles';

const useStyles = makeStyles(styles, {
  classNamePrefix: 'LearningOutcomesSkeleton',
});

const LearningOutcomesSkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Skeleton width="50%" />
      <div className={classes.content}>
        <div className={classes.list}>
          <Skeleton height={16} classes={{ root: classes.listItem }} count={3} />
        </div>
        <Skeleton variant="circular" classes={{ root: classes.picture }} />
      </div>
    </div>
  );
};

export default LearningOutcomesSkeleton;
